<template>
  <div class="about">
		<h1><span class="val col1">3</span> · sin(<span class="val col2">2</span>t + <span class="val col3">1</span>)</h1>
		<p>The sine function periodicity makes it useful in many fields, including generative art, sound, lights etc. and you are probably familiar with its waves. In this project, I'm trying to show another representation of its behavior in 3D graphics. <span class="vall">t</span> being the time, the other attributes can be modified to move objects on a scene, change the camera position or alter the light. 
<br><br>
		The application is developped in <kbd>Vue</kbd>, deployed with <kbd>Vercel</kbd> and the 3D graphics are made with <kbd>Three.js</kbd>.<br><br><br>
	<span class="ft"><a href="https://www.lorismat.com/" target=_blank>Loris Mat</a> | <a href="https://twitter.com/lorismat_" target=_blank>@lorismat_</a></span>
	</p>
  </div>
</template>

<style scoped>
kbd {
	font-weight: bold;
}

a {
	color:var(--black);
	text-decoration: none;
	box-shadow: 0 -2px inset var(--col2);
	padding: 5px 0px;
}

a:hover {
	box-shadow: none;
	color:var(--black);
}

.ft {
float:right;
}
.vall {
	font-family: var(--math);
}

p {
	max-width: 500px;
	margin: 0 auto;
	text-align: justify;
color: var(--black);
	font-size: 20px;
}

h1 {
	font-family: var(--math);
	margin: 40px 5px;
	color: var(--col1);
}

.val {
	font-family: var(--math-b);
	font-size: 22px;
}

.about {
}
</style>

